'use client';

var ModelError = /** @class */ (function () {
    function ModelError(data) {
        Object.assign(this, data);
    }
    return ModelError;
}());

export { ModelError as default };
//# sourceMappingURL=index.js.map
